import { createContext } from "react";
import { SubmitSocialCampaign } from "types/Campaign";

interface CustomProps {
  submitCampaign: SubmitSocialCampaign;
  setSubmitCampaign: Function;
  managingStep: string;
  setManagingStep: Function;
  socialApps: string[];
  setSocialApps: Function;
  pageDetails: any;
  setPageDetails: Function;
  pages: any;
  setPages: Function;
}

export const SocialCampaignContext = createContext({} as CustomProps);
